import { canSeeDashboard, type Module, type Permission, type Role } from "@clientflow/shared";
import { useQuery } from "@tanstack/react-query";

export type Me = {
  user: { id: string; email: string; name: string; mfaEnabled: boolean; hasPassword?: boolean } | null;
  mfaVerified?: boolean;
  /** When this session signed in (ISO); "Set a password" needs a recent sign-in. */
  signedInAt?: string;
  memberships?: Array<{ membershipId: string; firmId: string; firmName: string; role: Role; staffModules: string[] }>;
  invitations?: Array<{ membershipId: string; firmId: string; firmName: string; role: Role }>;
  activeFirmId?: string | null;
  role?: Role | null;
  staffModules?: string[];
  /** Services whose dashboard the owner has hidden from this person. */
  hiddenDashboards?: string[];
  permissions?: Permission[];
};

export function useMe() {
  return useQuery<Me>({ queryKey: ["/api/auth/me"], staleTime: 60_000 });
}

/** Whether this person sees a service's dashboard (its Overview tab). */
export function seesDashboard(me: Me | undefined, module: Module): boolean {
  return canSeeDashboard(me?.role, me?.staffModules, me?.hiddenDashboards, module);
}

export function hasPermission(me: Me | undefined, p: Permission): boolean {
  return !!me?.permissions?.includes(p);
}
